<template>
    <div class="w-100 h-100 d-flex flex-column">
            <b-row class="m-0 p-0 mb-1">

                <b-col cols="2" class="p-0 pr-1">
                    <select2 css-class="form-control"
                             name="courtMatterSelect"
                             :placeholder="placeholder"
                             :disabled="loadingData"
                             :options="courtMatters"
                             enable-ajax
                             :min-search-chars="2"
                             search-hint="Enter 2 or more characters to start searching. Start with a # to search by Epiq Reference only."
                             key-property="courtMatterId"
                             text-property="displayName"
                             v-model="currentCourtMatter"
                             v-on:search="findMatters"
                             v-on:select="reloadEvents"
                             in-b-modal
                             size="sm"></select2>
                </b-col>
                <b-col cols="2" class="p-0 pr-1">
                    <select2 ref="serviceTypeSelect"
                             name="serviceTypeSelect"
                             key="serviceTypeSelect"
                             placeholder="Service type"
                             :disabled="loadingData"
                             :options="serviceTypeOptions"
                             key-property="serviceTypeId"
                             text-property="name"
                             disable-search
                             allow-clear
                             v-model="currentServiceType"
                             v-on:select="reloadEvents"></select2>
                </b-col>
                <b-col cols="2" class="p-0 pr-1">
                    <select2 ref="jobLocationSelect"
                             name="jobLocationSelect"
                             key="jobLocationSelect"
                             placeholder="Job location"
                             :disabled="loadingData"
                             :options="jobLocationOptions"
                             key-property="courtLocationId"
                             text-property="name"
                             disable-search
                             allow-clear
                             v-model="currentJobLocation"
                             v-on:select="reloadEvents"></select2>
                </b-col>
                <b-col cols="2" class="p-0 pr-1">
                    <select2 ref="caseTypeSelect"
                             name="caseTypeSelect"
                             key="caseTypeSelect"
                             placeholder="Case type"
                             :disabled="loadingData"
                             :options="caseTypeOptions"
                             key-property="courtSittingMatterTypeId"
                             text-property="name"
                             disable-search
                             allow-clear
                             v-model="currentCaseType"
                             v-on:select="reloadEvents"></select2>
                </b-col>

                <b-col cols="1" class="pl-0">
                    <b-button @click="clearFilters" variant="outline-danger" class="h5 ml-1 bg-light">Clear</b-button>
                </b-col>

            </b-row>

        <ejs-schedule :firstDayOfWeek="1"
                      id='schedule'
                      ref='schedule' class="flex-grow-1"
                      height="100%"
                      width="100%"
                      :eventSettings='eventSettings'
                      :selectedDate='selectedDate'
                      :currentView="currentView"
                      :popupOpen="onPopupOpen"
                      :eventRendered="onEventRendered"
                      :created="schedulerCreated"
                      :showWeekNumber="true"
                      :rowAutoHeight="currentView == 'TimelineMonth'"
                      @update:currentView="(view) => currentView = view">
            <e-views>
                <e-view option="Month"></e-view>
                <e-view option="TimelineMonth"></e-view>
            </e-views>

            <template v-slot:tooltipTemplate="{ data }">
                <div class="">
                    <div class="content-area">
                        {{ getAppointmentType(data.type)  }}
                    </div>
                </div>
            </template>
        </ejs-schedule>

        <b-modal size="xl"
                 centered style="width: 1300px;"
                 :title="modalTitle(currentEvent.type)"
                 v-model="dailyDetailsDialogShown">

            <b-card>
                <b-card-text>
                    <div>
                        <b-form-group label-cols="6" label-cols-lg="4" label-size="md" :label="determineMatterNameLabel(currentEvent.type)" label-for="matterName" class="mb-1">
                            <b-form-input id="matterName" size="md" disabled v-model="currentEvent.subject"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="6" label-cols-lg="4" label-size="md" label="Start date" label-for="startDate" class="mb-1">
                            <b-form-input id="startDate" size="md" disabled v-model="currentEvent.startDate"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="6" label-cols-lg="4" label-size="md" label="End date" label-for="endDate" class="mb-1">
                            <b-form-input id="endDate" size="md" disabled v-model="currentEvent.endDate"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="6" label-cols-lg="4" label-size="md" :label="determineMatterNumberLabel(currentEvent.type)" label-for="caseNumber" class="mb-1" v-if="currentEvent.type!=2">
                            <b-form-input id="caseNumber" size="md" disabled v-model="currentEvent.caseNumber"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="6" label-cols-lg="4" label-size="md" label="Location" label-for="location" class="mb-1" v-if="currentEvent.type==2 || currentEvent.type==1">
                            <b-form-input id="location" size="md" disabled v-model="currentEvent.sittingDays[0].location"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="6" label-cols-lg="4" label-size="md" label="Service type" label-for="service-type" class="mb-1" v-if="currentEvent.type==2 || currentEvent.type==1">
                            <b-form-input id="service-type" size="md" disabled v-model="currentEvent.sittingDays[0].serviceTypeDisplayName"></b-form-input>
                        </b-form-group>

                        <!--court matter-->
                        <div v-if="currentEvent.type==0">
                            <hr />
                            <b-row v-for="(day,dayIndex) in currentEvent.sittingDays" :key="dayIndex" class="mb-1  border-secondary" style="font-size:13px;">
                                <b-col cols="2" class=""><span class="font-weight-bold">Day {{ dayIndex + 1 }}:</span> {{ formatDateTime(day.jobDate, 'DD MMM') }}</b-col>
                                <b-col>{{ day.serviceTypeDisplayName }}</b-col>
                                <b-col cols="4">{{ day.location }}</b-col>
                                <b-col>{{ day.statusDisplayName }}</b-col>
                                <b-col>{{ formatDateTime(day.startTime, 'HH:mm:A', true, false) }}</b-col>
                                <b-col>{{ formatDateTime(day.endTime, 'hh:mmA') }}</b-col>
                            </b-row>
                        </div>
                    </div>
                </b-card-text>
            </b-card>

            <template #modal-footer>
                <b-button v-on:click="dailyDetailsDialogShown = false" variant="secondary">Cancel</b-button>
            </template>

        </b-modal>

        <b-tooltip target="load-complete-orders" triggers="hover">
            Loading all completed orders might affect loading times of the Diary.
        </b-tooltip>

        <div class="mt-2">
            <b-button :disabled="loadingData" class="mr-1" size="sm" :variant="statusButtonFlags[2] == true ? 'warning' : 'outline-warning'" v-on:click="statusButtonClicked(2)">in quote</b-button>
            <b-button :disabled="loadingData" class="mr-1" size="sm" :variant="statusButtonFlags[5] == true ? 'secondary' : 'outline-secondary'" v-on:click="statusButtonClicked(5)">unconfirmed</b-button>
            <b-button :disabled="loadingData" class="mr-1" size="sm" :variant="statusButtonFlags[0] == true ? 'info' : 'outline-info'" v-on:click="statusButtonClicked(0)">confirmed</b-button>
            <b-button :disabled="loadingData" class="mr-1" size="sm" :variant="statusButtonFlags[4] == true ? 'primary' : 'outline-primary'" v-on:click="statusButtonClicked(4)">in progress</b-button>
            <b-button :disabled="loadingData" id="load-complete-orders" class="mr-1" size="sm" :variant="statusButtonFlags[3] == true ? 'success' : 'outline-success'" v-on:click="statusButtonClicked(3)">completed</b-button>
            <b-button :disabled="loadingData" class="mr-1" size="sm" :variant="statusButtonFlags[1] == true ? 'danger' : 'outline-danger'" v-on:click="statusButtonClicked(1)">canceled</b-button>
        </div>

        <!--<div class="mt-1">
            2 Order Status: (same colors as order widgets)
            <b-badge href="#" class="p-1 mr-1 text-dark" style="background-color: #CCC;">on hold</b-badge>
            <b-badge href="#" class="p-1 mr-1 text-dark" style="background-color: #90EE90;">confirmed</b-badge>
            <b-badge href="#" class="p-1 mr-1 text-dark" style="background-color: #32CD32;">in progress</b-badge>
            <b-badge href="#" class="p-1 mr-1 text-dark" style="background-color: green;">completed</b-badge>
            <b-badge href="#" class="p-1 mr-1 text-dark" style="background-color: red;">cancelled</b-badge>
            <b-badge href="#" class="p-1 mr-1 text-dark" style="background-color: orange;">in quote</b-badge>
            <b-badge href="#" class="p-1 mr-1 text-dark" style="background-color: blue;">unconfirmed</b-badge>
        </div>
        <div class="mt-1">
            3 Order Status: (same colors as order widgets)
            <b-badge href="#" class="p-1 mr-1 font-weight-light" style="background-color: #CCC;">on hold</b-badge>
            <b-badge href="#" class="p-1 mr-1 font-weight-light" style="background-color: #90EE90;">confirmed</b-badge>
            <b-badge href="#" class="p-1 mr-1 font-weight-light" style="background-color: #32CD32;">in progress</b-badge>
            <b-badge href="#" class="p-1 mr-1 font-weight-light" style="background-color: green;">completed</b-badge>
            <b-badge href="#" class="p-1 mr-1 font-weight-light" style="background-color: red;">cancelled</b-badge>
            <b-badge href="#" class="p-1 mr-1 font-weight-light" style="background-color: orange;">in quote</b-badge>
            <b-badge href="#" class="p-1 mr-1 font-weight-light" style="background-color: blue;">unconfirmed</b-badge>
        </div>
        <div class="mt-1">
            4 Order Status: (same colors as order widgets)
            <b-badge href="#" class="p-1 mr-1 text-dark font-weight-light" style="background-color: #CCC;">on hold</b-badge>
            <b-badge href="#" class="p-1 mr-1 text-dark font-weight-light" style="background-color: #90EE90;">confirmed</b-badge>
            <b-badge href="#" class="p-1 mr-1 text-dark font-weight-light" style="background-color: #32CD32;">in progress</b-badge>
            <b-badge href="#" class="p-1 mr-1 text-dark font-weight-light" style="background-color: green;">completed</b-badge>
            <b-badge href="#" class="p-1 mr-1 text-dark font-weight-light" style="background-color: red;">cancelled</b-badge>
            <b-badge href="#" class="p-1 mr-1 text-dark font-weight-light" style="background-color: orange;">in quote</b-badge>
            <b-badge href="#" class="p-1 mr-1 text-dark font-weight-light" style="background-color: blue;">unconfirmed</b-badge>
        </div>

        =============================================================

        <div class="mt-1 font-weight-light">
            Order Status:(default color scheme)
            <b-badge href="#" class="p-1 mr-1 font-weight-lighter" variant="secondary">on hold</b-badge>
            <b-badge href="#" class="p-1 mr-1 font-weight-lighter" variant="info">confirmed</b-badge>
            <b-badge href="#" class="p-1 mr-1 font-weight-lighter" variant="primary">in progress</b-badge>
            <b-badge href="#" class="p-1 mr-1 font-weight-lighter" variant="success">completed</b-badge>
            <b-badge href="#" class="p-1 mr-1 font-weight-lighter" variant="danger">cancelled</b-badge>
            <b-badge href="#" class="p-1 mr-1 font-weight-lighter" variant="warning">in quote</b-badge>
            <b-badge href="#" class="p-1 mr-1 font-weight-lighter" style="background-color: #08e8de;">unconfirmed</b-badge>
        </div>

        <div class="mt-1 font-weight-light">
            Order Status: (default color scheme)
            <b-badge href="#" class="p-1 mr-1 font-weight-lighter " style="color:#000000;" variant="secondary">on hold</b-badge>
            <b-badge href="#" class="p-1 mr-1 font-weight-lighter " style="color:#000000;" variant="info">confirmed</b-badge>
            <b-badge href="#" class="p-1 mr-1 font-weight-lighter " style="color:#000000;" variant="primary">in progress</b-badge>
            <b-badge href="#" class="p-1 mr-1 font-weight-lighter " style="color:#000000;" variant="success">completed</b-badge>
            <b-badge href="#" class="p-1 mr-1 font-weight-lighter " style="color:#000000;" variant="danger">cancelled</b-badge>
            <b-badge href="#" class="p-1 mr-1 font-weight-lighter " style="color:#000000;" variant="warning">in quote</b-badge>
            <b-badge href="#" class="p-1 mr-1 font-weight-lighter" style="background-color: #afeeee; color:#000000;">unconfirmed</b-badge>
        </div>-->
    </div>
</template>

<script>
    import $ from 'jquery';
    import Vue from 'vue';
    import axios from 'axios';
    import { TooltipPlugin } from "@syncfusion/ej2-vue-popups";
    import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
    import { DataManager } from '@syncfusion/ej2-data';
    import { CustomDataAdaptor } from '@syncfusion/ej2-data';
    import { SchedulePlugin, Week, WorkWeek, Month, TimelineMonth, TimelineViews } from '@syncfusion/ej2-vue-schedule';

    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    Vue.use(ButtonPlugin);
    Vue.use(TooltipPlugin);
    Vue.use(SchedulePlugin);

    export default {
        name: 'DiaryNew',
        mixins: [ErrorsMixin, DateTimeMixin],
        provide: {
            schedule: [Week, WorkWeek, Month, TimelineMonth, TimelineViews]
        },
        props: {
            apiBaseUrl: {
                type: String,
                required: false,
                deafault: "/api"
            },
            apiControllerUrl: {
                type: String,
                required: true
            }
        },
        data() {
            return {

                loadingData: false,
                statusButtonFlags: [true, true, true, false, true, true],
                statusStringsArray: ['Confirmed', 'Canceled', 'InQuote', 'Completed', 'InProgress', 'Unconfirmed'],

                // modal
                dailyDetailsDialogShown: false,

                //modalData: null,
                //listData: null,
                //pageSettings: { pageSize: 5 },

                currentCourtMatter: null,
                currentServiceType: null,
                currentJobLocation: null,
                currentJobStatus: null,
                currentCaseType: null,

                //monthOptions: [
                //    { value: 1, text: '1' }, { value: 2, text: '2' }, { value: 3, text: '3' }, { value: 4, text: '4' }, { value: 5, text: '5' }, { value: 6, text: '6' },
                //    { value: 7, text: '7' }, { value: 8, text: '8' }, { value: 9, text: '9' }, { value: 10, text: '10' }, { value: 11, text: '11' }, { value: 12, text: '12' }
                //],
                //yearOptions: [{ value: 2022, text: '2022' }, { value: 2023, text: '2023' }, { value: 2024, text: '2024' }, { value: 2025, text: '2025' }],
                //yearToLoad: 2023,
                //monthToLoad: 12, //

                // <scheduler> stuff
                selectedDate: new Date(), //Months are 0 indexed - jan = 0

                eventSettings: {
                    dataSource: new DataManager({
                        url: '/api/Diary/calendarmonth',
                        adaptor: new CustomDataAdaptor({
                            getData: this.getData,
                            //addRecord: this.addRecord,
                            //updateRecord: this.updateRecord,
                            //deleteRecord: this.deleteRecord,
                            //batchUpdate: this.batchUpdate
                        })
                    }),
                    fields: {
                        id: 'id',
                        subject: { name: 'subject' },
                        isAllDay: { name: 'isAllDay' },
                        startTime: { name: 'startDate' },
                        endTime: { name: 'endDate' },
                        type: { name: 'type' }
                    },
                    enableTooltip: true,
                    tooltipTemplate: 'tooltipTemplate'
                },

                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy' },
                timeFormatOptions: { type: 'dateTime', format: 'hh:mm a' },

                currentEvent: {
                    id: null,
                    startDate: null,
                    endDate: null,
                    subject: null,
                    caseName: null,
                    caseNumber: null,
                    caseTypeDisplayName: null,
                    type: null,
                    sittingDays: []
                },

                courtMatters: null,
                serviceTypeOptions: [{ value: null, text: 'Service type' }],
                jobLocationOptions: [{ value: null, text: 'Job location' }],
                caseTypeOptions: [{ value: null, text: 'Case type' }],
                jobStatusOptions: [{ value: null, text: 'Job status' }],

                //startDate: new Date(),
                //endDate: new Date(),
                
                currentView: 'Month', // used by the Schedule component
                schedulerInstance: null,
            }
        },

        computed: {
            placeholder: function () {
                return this.$t('Vue.Shared.Select2Placeholder.CourtMatter');
            },
        },

        methods: {

            statusButtonClicked(index) {
                Vue.set(this.statusButtonFlags, index, !this.statusButtonFlags[index]);
                this.reloadEvents();
            },

            getAppointmentType: function (type) {
                switch (type) {
                    case 0: return this.$t('Vue.Diary.Diary.AppointmentType.CourtMatter');
                    case 1: return this.$t('Vue.Diary.Diary.AppointmentType.Interview');
                    case 2: return this.$t('Vue.Diary.Diary.AppointmentType.ListCourt');
                    default: return 'Unknown appointment type';
                }
            },

            modalTitle: function (type) {
                switch (type) {
                    case 0: return this.$t('Vue.Diary.Diary.ModalTitle.CourtMatter');
                    case 1: return this.$t('Vue.Diary.Diary.ModalTitle.Interview');
                    case 2: return this.$t('Vue.Diary.Diary.ModalTitle.ListCourt');
                    default: return 'Details';
                }
            },

            determineMatterNameLabel: function (type) {
                switch (type) {
                    case 0: return this.$t('Vue.Diary.Diary.AppointmentSubjectLabel.CourtMatter');
                    case 1: return this.$t('Vue.Diary.Diary.AppointmentSubjectLabel.Interview');
                    case 2: return this.$t('Vue.Diary.Diary.AppointmentSubjectLabel.ListCourt');
                    default: return 'Name';
                }
            },

            determineMatterNumberLabel: function (type) {
                switch (type) {
                    case 0: return this.$t('Entities.Shared.MatterNumber');
                    case 1: return 'Related matter or case';
                    case 2: return '';
                    default: return 'Number';
                }
            },
            onPopupOpen: function (args) {

                if (args.data.event) {
                    return;
                }

                if (!("subject" in args.data)) {
                    // this line prevents the default ADD dialog not to show if there are no matters for that day
                    args.cancel = true;
                    return;
                }

                this.currentEvent.startDate = this.formatDateTime(args.data.startDate, 'DD MMM yyyy');
                this.currentEvent.endDate = this.formatDateTime(args.data.endDate, 'DD MMM yyyy');
                this.currentEvent.subject = args.data.subject;
                this.currentEvent.type = args.data.type;
                this.currentEvent.caseName = args.data.caseName;
                this.currentEvent.caseNumber = args.data.caseNumber;
                this.currentEvent.caseTypeDisplayName = args.data.caseTypeDisplayName;
                this.currentEvent.sittingDays = args.data.days;

                this.dailyDetailsDialogShown = true;
                args.cancel = true;
            },

            getData: function (args) {

                if (args == null) {
                    // this line prevents the default ADD dialog not to show if there are no matters for that day
                    return;
                }

                this.loadingData = true;

                var params = JSON.parse(args.data);

                // this block is new since the introduction of status buttons
                this.currentJobStatus = [];
                for (var i = 0; i < this.statusStringsArray.length; i++) {
                    if (this.statusButtonFlags[i])
                        this.currentJobStatus.push(this.statusStringsArray[i]);
                }

                var data = {
                    courtMatterId: this.currentCourtMatter,
                    serviceTypeId: this.currentServiceType,
                    locationId: this.currentJobLocation,
                    status: this.currentJobStatus,
                    caseTypeId: this.currentCaseType,
                    startDate: this.parseDateTime(params.StartDate, null, true, false),
                    endDate: this.parseDateTime(params.EndDate, null, true, false),
                };

                var url = this.$urlHelper.getApiUrl('Diary', 'calendarmonth');
                axios
                    .post(url, JSON.stringify(data),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(response => {
                        args.onSuccess(response.data);
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                    })
                    .finally(() => {
                        this.loadingData = false;
                    });
            },

            findMatters: function (params, success, failure) {
                var filter = {
                    searchTerm: ''
                };
                if (typeof (params.data.term) != "undefined")
                    filter.searchTerm = params.data.term;
                var url = this.$urlHelper.getApiUrl('courtmatter', null, ['find']);

                this.lastSearchTerm = params.data.term;
                axios
                    .post(url, JSON.stringify(filter),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(function (response) {
                        var mappedData = response.data;
                        if (mappedData != null) {
                            mappedData = $.map(mappedData, function (obj) {
                                obj.id = obj.courtMatterId;
                                obj.text = obj.displayName;
                                return obj;
                            });
                        }
                        success({ results: mappedData });
                    })
                    .catch(function (error) {
                        failure(error);
                    });
            },

            // triggered by all UI elemnets
            reloadEvents: function () {
                if (this.schedulerInstance != null) {
                    this.schedulerInstance.showSpinner();
                    this.schedulerInstance.refreshEvents();
                }
            },

            loadCourtMatters: function () {

                this.courtMatters = null;
                var url = this.$urlHelper.getApiUrl('courtmatter', 'all');

                axios
                    .get(url)
                    .then(response => {
                        this.courtMatters = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    })
                    .finally(() => {

                    });
            },

            loadServiceTypes: function () {

                this.serviceTypeOptions = null;
                var url = this.$urlHelper.getApiUrl('servicetype', 'all');

                axios
                    .get(url)
                    .then(response => {
                        this.serviceTypeOptions = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    })
                    .finally(() => {

                    });
            },
            loadJobLocations: function () {

                this.jobLocationOptions = null;
                var url = this.$urlHelper.getApiUrl('courtregistry', 'alllocations');

                axios
                    .get(url)
                    .then(response => {
                        this.jobLocationOptions = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    })
                    .finally(() => {

                    });
            },
            loadCaseTypes: function () {

                this.caseTypeOptions = null;
                var url = this.$urlHelper.getApiUrl('courtmatter', 'allmattertypes');

                axios
                    .get(url)
                    .then(response => {
                        this.caseTypeOptions = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    })
                    .finally(() => {

                    });
            },
            loadJobStatuses: function () {

                this.jobStatusOptions = null;
                var url = this.$urlHelper.getApiUrl('diary', 'diarystatuses');

                axios
                    .get(url)
                    .then(response => {
                        this.jobStatusOptions = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    })
                    .finally(() => {

                    });
            },

            onEventRendered: function (args) {

                var statusColor = '#CCCCCC';

                if (args.data.statusDisplayName == 'In Quote') {
                    statusColor = '#ffc107';
                    // setting the font color to black if backgrond is yellow
                    args.element.style.color = '#000000';
                }
                if (args.data.statusDisplayName == 'Unconfirmed') statusColor = 'gray';
                if (args.data.statusDisplayName == 'Confirmed') statusColor = '#17a2b8';
                if (args.data.statusDisplayName == 'In Progress') statusColor = '#007bff';
                if (args.data.statusDisplayName == 'Completed') statusColor = '#28a745';
                if (args.data.statusDisplayName == 'Cancelled') statusColor = '#dc3545';

                args.element.style.backgroundColor = statusColor;

                //    // Base colors definitions
                //    $blue: #007bff!default;
                //$indigo: #6610f2!default;
                //$purple: #6f42c1!default;
                //$pink: #e83e8c!default;
                //$red: #dc3545!default;
                //$orange: #fd7e14!default;
                //$yellow: #ffc107!default;
                //$green: #28a745!default;
                //$teal: #20c997!default;
                //$cyan: #17a2b8!default;

                //// Theme color default definitions
                //$primary: $blue!default;
                //$secondary: $gray - 600!default;
                //$success: $green!default;
                //$info: $cyan!default;
                //$warning: $yellow!default;
                //$danger: $red!default;
                //$light: $gray - 100!default;
                //$dark: $gray - 800!default;

            },

            clearFilters: function () {
                this.loadingData = false; 
                this.currentCourtMatter = null;
                this.currentServiceType = null;
                this.currentJobLocation = null;
                this.currentJobStatus = null;
                this.currentCaseType = null;
                this.reloadEvents();
            },

            schedulerCreated: function () {
                this.schedulerInstance = this.$refs.schedule.ej2Instances;
            }
        },

        mounted: function () {
            this.loadServiceTypes();
            this.loadCourtMatters();
            this.loadJobLocations();
            this.loadCaseTypes();
        }
    }
</script>

<style scoped>

    /*this will change the width of the cells only for the timeline month view*/
    .e-schedule::v-deep .e-timeline-month-view .e-work-cells,
    .e-schedule::v-deep .e-timeline-month-view .e-content-wrap table col,
    .e-schedule::v-deep .e-timeline-month-view .e-date-header-wrap table col {
        width: 5rem;
    }
</style>